import moment from 'moment';
import { omit } from 'lodash';
import { SurveyTaskCompleterModel } from './SurveyTaskCompleterModel';
export class RaffleCampaignWinnerModel {
    constructor(payload) {
        Object.assign(this, omit(payload, 'winner'));
        this.winner = new SurveyTaskCompleterModel(payload.winner);
    }
    get wonAt() {
        const createdAt = new Date(this.createdAt);
        return moment(createdAt).format('MMM D, Y');
    }
}
